import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export function QuoteSection() {
  const { t } = useLanguage();

  return (
    <section className="py-24 bg-primary">
      <div className="container px-4">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-primary-foreground mb-4">
            {t.quotes.title}{" "}
            <span className="font-serif italic">{t.quotes.titleItalic}</span>
          </h2>
          <p className="text-lg text-primary-foreground/70 max-w-2xl mx-auto">
            {t.quotes.subtitle}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {t.quotes.items.map((quote, index) => (
            <motion.div
              key={quote.author}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.15 }}
              className="relative"
            >
              <div className="bg-primary-foreground/5 backdrop-blur-sm rounded-2xl p-8 h-full border border-primary-foreground/10">
                <Quote className="h-10 w-10 text-accent mb-6" />
                
                <blockquote className="text-lg text-primary-foreground mb-6 leading-relaxed">
                  „{quote.text}"
                </blockquote>

                <div className="flex items-center gap-4 mt-auto">
                  <div className="w-12 h-12 rounded-full bg-accent/20 flex items-center justify-center">
                    <span className="text-accent font-bold text-lg">
                      {quote.author.split(' ').map(n => n[0]).join('')}
                    </span>
                  </div>
                  <div>
                    <div className="font-semibold text-primary-foreground">
                      {quote.author}
                    </div>
                    <div className="text-sm text-primary-foreground/60">
                      {quote.role}, {quote.company}
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
